// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Footer-module--cds--assistive-text--b0f19";
export var cdsHideFeedback = "Footer-module--cds--hide-feedback--b3bb5";
export var cdsShowFeedback = "Footer-module--cds--show-feedback--eca3c";
export var cdsSkeleton = "Footer-module--cds--skeleton--dfed4";
export var cdsVisuallyHidden = "Footer-module--cds--visually-hidden--79839";
export var content = "Footer-module--content--e6561";
export var footer = "Footer-module--footer--676fe";
export var grid = "Footer-module--grid--ec6b8";
export var listItem = "Footer-module--listItem--06d5b";
export var logo = "Footer-module--logo--92ee4";
export var nav = "Footer-module--nav--3d17a";